import {Model} from "@/app/Model";

export class PenalePercorsoFlow {
    public capo_imputazione_legge: string = "";
    public importo_evaso_active: boolean = false;
    public importo_evaso_min: number = Model.lista_importi_minMax[0];
    public importo_evaso_max: number = Model.lista_importi_minMax[1];
    public importo_evaso_da: number = Model.lista_importi_minMax[0];
    public importo_evaso_a: number = Model.lista_importi_minMax[1];
    public assoluzione: string = "";
    public assoluzione_motivo: string = "";
    public pena_principale: string = "";

    public paginazione_tot: number = 0;
    public paginazione_start: number = 0; //numero di pagina
    public paginazione_rows: number = Model.pagination_size;
    public paginazione_pages: number = 0;

    public diritto_paginazione_tot: number = 0;
    public diritto_paginazione_start: number = 0; //numero di pagina
    public diritto_paginazione_rows: number = Model.pagination_size;
    public diritto_paginazione_pages: number = 0;

    public reset(): void {
        this.capo_imputazione_legge = "";
        this.importo_evaso_active = false;
        this.importo_evaso_min = Model.lista_importi_minMax[0];
        this.importo_evaso_max = Model.lista_importi_minMax[1];
        this.importo_evaso_da = Model.lista_importi_minMax[0];
        this.importo_evaso_a = Model.lista_importi_minMax[1];
        this.assoluzione = "";
        this.assoluzione_motivo = "";
        this.pena_principale = "";

        this.paginazione_tot = 0;
        this.paginazione_start = 0;
        this.paginazione_rows = Model.pagination_size;
        this.paginazione_pages = 0;

        this.diritto_paginazione_tot = 0;
        this.diritto_paginazione_start = 0;
        this.diritto_paginazione_rows = Model.pagination_size;
        this.diritto_paginazione_pages = 0;
    }
}